import { render, staticRenderFns } from "./RelatorioConsolidadoRentabilidade.vue?vue&type=template&id=50b43422"
import script from "./RelatorioConsolidadoRentabilidade.vue?vue&type=script&lang=js"
export * from "./RelatorioConsolidadoRentabilidade.vue?vue&type=script&lang=js"
import style0 from "./RelatorioConsolidadoRentabilidade.vue?vue&type=style&index=0&id=50b43422&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports